var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"outlined":true,"loading":_vm.loading,"disabled":_vm.loading,"color":"primary"},on:{"click":_vm.submit}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',[_vm._v(" mdi-logout ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }